import './sticky-sidebar.min';
import * as helpers from '../helpers';

export default function fixedSidebar() {
    const summary = document.querySelector('.summary');

    if (window.innerWidth > 1338 && summary) {
        if (helpers.hasClass(summary, 'is-affixed')) {
            return;
        }

        const offsetTop = 80;

        const sidebar = new StickySidebar('.summary', {
            containerSelector: '.sidebar',
            innerWrapperSelector: '.summary__wrapper',
            topSpacing: offsetTop,
        });

        window.addEventListener('scroll', () => {
            const summaryPosY = summary.getBoundingClientRect().top;

            if (summaryPosY >= offsetTop) {
                sidebar.sidebarInner.style.position = 'static';
            } else if (sidebar.affixedType === 'VIEWPORT-TOP') {
                sidebar.sidebarInner.style.position = 'fixed';
            } else {
                sidebar.sidebarInner.style.position = 'relative';
            }
        });
    }
}
